import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldModule } from '@appkit4/angular-components/field';
import { ModalModule } from '@appkit4/angular-components/modal';
import { PanelModule } from '@appkit4/angular-components/panel';
import { TabsModule } from '@appkit4/angular-components/tabs';
import { TooltipModule } from '@appkit4/angular-components/tooltip';
import { FormGeneratorEngineModule } from '@core/form-generator-engine';
import { GridModule } from '@shared/modules/grid/grid.module';
import { PrimeGridFiltersModule } from '@shared/modules/prime-grid-filters/prime-grid-filters.module';
import { SharedModule } from '@shared/shared.module';
import { TableModule } from 'primeng/table';
import { ManageEntitiesModule } from '../manage-entities/manage-entities.module';
import { AddEntityComponent } from './components/add-entity/add-entity.component';
import { CommentFieldComponent } from './components/comment-field/comment-field.component';
import { ExplanationFieldComponent } from './components/explanation-field/explanation-field.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { RulesEngineViewComponent } from './components/rules-engine-view/rules-engine-view.component';
import { SecurityActionModalComponent } from './components/security-action-date-modal/security-action-date-modal';
import { SecurityDetailsComponent } from './components/security-details/security-details.component';
import { SecurityFormComponent } from './components/security-form/security-form.component';
import { SecurityStatusGridIconComponent } from './components/security-status-grid-icon/security-status-grid-icon.component';
import { SelectOrAddEntityComponent } from './components/select-or-add-entity/select-or-add-entity.component';
import { UpsertGeneralRatesComponent } from './components/upsert-general-rates/upsert-general-rates.component';
import { UpsertSpecificAdviceComponent } from './components/upsert-specific-advice/upsert-specific-advice.component';
import { PortfolioRoutingModule } from './portfolio-routing.module';
import { FormSchemaFactoryService } from './services/form-schema-factory.service';
import { RulesFormManager } from './services/rules-form-manager';
import { SchemaFactoryService } from './services/schema-factory.service';
import { SecurityFormGroupDefinition } from './services/security-form-group-definition';
import { SecurityService } from './services/security.service';
import { TaxRulesService } from './services/tax-rules.service';

@NgModule({
  declarations: [
    UpsertGeneralRatesComponent,
    UpsertSpecificAdviceComponent,
    AddEntityComponent,
    SecurityDetailsComponent,
    PortfolioComponent,
    SecurityActionModalComponent,
    SecurityFormComponent,
    SelectOrAddEntityComponent,
    RulesEngineViewComponent,
    SecurityStatusGridIconComponent,
    ExplanationFieldComponent,
    CommentFieldComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PortfolioRoutingModule,
    ReactiveFormsModule,
    FieldModule,
    ModalModule,
    PanelModule,
    FormsModule,
    TableModule,
    FormGeneratorEngineModule.forRoot({
      schemaFactory: FormSchemaFactoryService,
    }),
    ManageEntitiesModule,
    TabsModule,
    TooltipModule,
    PrimeGridFiltersModule,
    GridModule,
  ],
  providers: [
    TaxRulesService,
    SecurityService,
    FormSchemaFactoryService,
    SchemaFactoryService,
    SecurityFormGroupDefinition,
    {
      provide: RulesFormManager,
      useValue: new RulesFormManager([]),
    },
  ],
})
export class PortfolioModule {}
